var map = {
	"./8/Spectate/RegulationLogosSection.layout": [
		50019,
		6080
	],
	"./96/Spectate/RegulationLogosSection.layout": [
		87218,
		8619
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 72865;
module.exports = webpackAsyncContext;